// extracted by mini-css-extract-plugin
export default {"no-scroll-button":"VNQZuX","noScrollButton":"VNQZuX"};